"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-e79e5174"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { className: "layout-tab-bar" };
var _hoisted_2 = { className: "layout-tab-bar-content" };
var _hoisted_3 = ["href"];
var _hoisted_4 = { className: "nav-title" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        vue_1.createElementVNode("div", _hoisted_2, [
            (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.tabBarList, function (item) {
                return (vue_1.openBlock(), vue_1.createElementBlock("a", {
                    key: item.key,
                    href: item.href,
                    class: vue_1.normalizeClass(['nav-item', _ctx.active === item.key && 'active'])
                }, [
                    vue_1.createElementVNode("i", {
                        class: vue_1.normalizeClass(["icon", [_ctx.active === item.key ? item.icon + "-selected" : item.icon + "-real"]])
                    }, null, 2),
                    vue_1.createElementVNode("span", _hoisted_4, vue_1.toDisplayString(item.title), 1)
                ], 10, _hoisted_3));
            }), 128))
        ])
    ]));
}
exports.render = render;
